import { CommonHelperFunctions, IOfflineTable } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class OfflineTablesService {
  public static async getAll() {
    try {
      const res = await Axios.get<null, AxiosResponse<IOfflineTable>>(`${backendUrl}/OfflineTables`);
      return res;
    } catch (e: any) {
      KMainFunctions.exceptionHandler(e);
      return e;
    }
  }

  public static async save(payload: IOfflineTable) {
    try {
      return await Axios.post<IOfflineTable, AxiosResponse>(`${backendUrl}/OfflineTables`, payload);
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
      return e;
    }
  }

  public static async delete(tableName: string) {
    try {
      return await Axios.delete<null, AxiosResponse>(`${backendUrl}/OfflineTables`, { params: { tableName } });
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
      return e;
    }
  }
}
